import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";


export class BringozSlaBarComponent implements IController {

  dates: any;

  dateLabels: any;
  lastDateLabel: any;

  constructor() {
  }

  $onInit() {
    this.dateLabels = _.initial(this.dates);
    this.lastDateLabel = _.last(this.dates);
  };

  $onChanges(changes) {
    if (changes.dates && !changes.dates.isFirstChange()) {
      this.$onInit();
    }
  };

}

angular
  .module('bringoz.admin.commons')
  .component('bringozSlaBar', {
    bindings: {
      dates: '<'
    },
    templateUrl: 'app/modules/commons/components/bringoz-sla-bar/bringoz-sla-bar.html',
    controller: BringozSlaBarComponent
  });
